function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as https from 'https';
import * as http from 'http';
/**
 * Creates HTTP and HTTPS agents with connection pooling and keep-alive settings
 * optimized for high-volume outbound requests to external services
 */ export function createHttpAgents(config = {}) {
    const defaultConfig = {
        timeout: 30000,
        keepAlive: true,
        keepAliveMsecs: 30000,
        scheduling: 'lifo'
    };
    const finalConfig = _object_spread({}, defaultConfig, config);
    const httpsAgent = new https.Agent({
        maxSockets: finalConfig.maxSockets,
        maxFreeSockets: finalConfig.maxFreeSockets,
        timeout: finalConfig.timeout,
        keepAlive: finalConfig.keepAlive,
        keepAliveMsecs: finalConfig.keepAliveMsecs,
        scheduling: finalConfig.scheduling
    });
    const httpAgent = new http.Agent({
        maxSockets: finalConfig.maxSockets,
        maxFreeSockets: finalConfig.maxFreeSockets,
        timeout: finalConfig.timeout,
        keepAlive: finalConfig.keepAlive,
        keepAliveMsecs: finalConfig.keepAliveMsecs,
        scheduling: finalConfig.scheduling
    });
    return {
        httpsAgent,
        httpAgent,
        config: finalConfig
    };
}
/**
 * Creates a specialized agent configuration for catalog service requests
 * with conservative settings to prevent connection storms that cause container restarts
 */ export function createCatalogServiceAgent() {
    return createHttpAgents({
        // Sockets settings have been removed and will fall back to the default agent's configuration (maxSockets: 50).
        timeout: 120000,
        keepAlive: true,
        keepAliveMsecs: 60000,
        scheduling: 'fifo'
    });
}
/**
 * Global catalog service agent instance - reused across all catalog requests
 * This prevents the connection storms that were causing container restarts
 */ export const catalogServiceAgent = createCatalogServiceAgent();
